import { render, staticRenderFns } from "./AppBarHelpButton.vue?vue&type=template&id=8f7cb984&scoped=true&"
import script from "./AppBarHelpButton.vue?vue&type=script&lang=js&"
export * from "./AppBarHelpButton.vue?vue&type=script&lang=js&"
import style0 from "./AppBarHelpButton.vue?vue&type=style&index=0&id=8f7cb984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7cb984",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
